export default __webpack_public_path__ + "images/GA.6b5f437.png";